import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Subject, throttleTime } from 'rxjs';

type ButtonIconPosition = 'left' | 'right' | 'top' | 'bottom';
type ButtonSeverity = 'success' | 'primary' | 'secondary' | 'info' | 'warn' | 'danger' | 'help' | 'contrast' | null | undefined;
type ButtonSize = 'small' | 'large' | undefined;
type ButtonVariant = 'outlined' | 'text' | undefined;

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
  standalone: true,
  imports: [ButtonModule, TooltipModule]
})
export class CustomButtonComponent implements OnChanges {
  private clickSubject = new Subject<Event>();
  class: string = "";

  @Input() disabled: boolean = false;
  @Input() icon: string = "";
  @Input() iconPos: ButtonIconPosition = "left";
  @Input() label: string = "";
  @Input() link: boolean = false;
  @Input() severity: ButtonSeverity = "primary";
  @Input() size: ButtonSize = "small";
  @Input() variant: ButtonVariant = "outlined";
  @Input() title: string = "";
  @Input() width?: string;
  @Output() onClick = new EventEmitter<Event>();

  ngOnInit() {
    this.clickSubject.pipe(throttleTime(2000)).subscribe(event => {
      this.onClick.emit(event);
    });
  }

  ngOnChanges(changes: any) {
    if (changes['severity']) {
      const value = changes['severity'].currentValue;
      this.class = value == null ? 'no-severity' : '';
    }
  }

  get computedStyle(): Record<string, string> {
    return this.width ? { width: this.width } : { width: '4.5rem' };
  }

  handleClick(event: Event) {
    this.clickSubject.next(event);
  }

}
